export default __webpack_public_path__ + "static/media/testimonial3-150x150.05bab6f2.png";